import clsx from "clsx";

export default function ValueDisplay({
  isOldValue,
  children,
  className,
}: Readonly<{
  isOldValue?: boolean;
  children: React.ReactNode;
  className?: string;
}>) {
  return (
    <span
      className={clsx(
        "text-body text-size-body",
        {
          "line-through text-on-disabled": isOldValue,
        },
        className,
      )}
    >
      {children}
    </span>
  );
}
